import { useEffect, useMemo, useRef } from "react";

const TOKEN_RE = /[^\n.!?…]*[.!?…]+(?:[ \u00a0]*["»”)])*|[^\n.!?…]+|\n+/g;
const PAUSE_WEIGHT = 12;

export function splitStory(raw) {
  let idx = 0;
  const text = raw.replace(/« /g, "«\u00a0").replace(/ (»|[!?;:])/g, "\u00a0$1");
  return (text.match(TOKEN_RE) || []).map((t) => {
    const isSentence = /\S/.test(t) && !/^\n+$/.test(t);
    return { text: t, idx: isSentence ? idx++ : -1 };
  });
}

export const sentencesOf = (tokens) => tokens.filter((t) => t.idx >= 0).map((t) => t.text.trim());

// Estime la phrase lue à partir de la progression de l'audio (0→1).
export function sentenceAtFraction(fraction, leadText, sentences) {
  if (fraction == null || !sentences.length) return -1;
  const lead = leadText.length + PAUSE_WEIGHT;
  const weights = sentences.map((s) => s.length + PAUSE_WEIGHT);
  const total = lead + weights.reduce((a, b) => a + b, 0);
  let pos = fraction * total - lead;
  if (pos < 0) return -1;
  for (let i = 0; i < weights.length; i++) {
    if (pos < weights[i]) return i;
    pos -= weights[i];
  }
  return weights.length - 1;
}

export function sentenceStartFraction(i, leadText, sentences) {
  const lead = leadText.length + PAUSE_WEIGHT;
  const weights = sentences.map((s) => s.length + PAUSE_WEIGHT);
  const total = lead + weights.reduce((a, b) => a + b, 0);
  return (lead + weights.slice(0, i).reduce((a, b) => a + b, 0)) / total;
}

export default function HighlightedStory({ tokens, current, scale = 1 }) {
  const refs = useRef({});
  useEffect(() => {
    const el = refs.current[current];
    if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
  }, [current]);
  return useMemo(() => (
    <div className="font-patient text-gray-800 text-[calc(1.5rem*var(--story-scale))] sm:text-[calc(1.875rem*var(--story-scale))] leading-relaxed whitespace-pre-wrap transition-[font-size] duration-300"
      style={{ "--story-scale": scale }} data-testid="story-text">
      {tokens.map((t, i) => (t.idx < 0 ? <span key={i}>{t.text}</span> : (
        <span key={i} ref={(el) => { refs.current[t.idx] = el; }} data-testid={`story-sentence-${t.idx}`}
          data-active={current === t.idx ? "true" : "false"}
          className={`rounded-lg transition-colors duration-500 ${current === t.idx ? "bg-amber-200/80 text-gray-900" : current >= 0 ? "text-gray-500" : ""}`}>
          {t.text}
        </span>
      )))}
    </div>
  ), [tokens, current, scale]);
}
